<template>
  <v-list-item
    v-if="!children"
    link
    exact
    :to="link"
    class="menu-tree-item"
  >
    <v-list-item-icon>
      <v-icon v-if="hasIcon">
        {{ icon }}
      </v-icon>
    </v-list-item-icon>

    <v-list-item-content>
      <v-list-item-title>{{ title }}</v-list-item-title>
    </v-list-item-content>
  </v-list-item>
  <v-list-group
    v-else
    v-model="open"
    :prepend-icon="icon"
    class="menu-tree-group"
  >
    <template v-slot:activator>
      <v-list-item-content>
        <v-list-item-title>{{ title }}</v-list-item-title>
      </v-list-item-content>
    </template>

    <MenuTreeItem
      v-for="(child) in children"
      :key="child.title"
      :hasIcon="false"
      :link="child.link"
      :icon="child.icon"
      :title="child.title"
      :forceOpen="forceOpen"
      :children="child.children"
    />
  </v-list-group>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name  : 'MenuTreeItem',
  data  : () => ({ open: true }),
  props : ["link", "icon", "title", "children", "hasIcon", "forceOpen"],
  created() {
    this.open = this.children?.some(item => item.link === this.$route.path) ?? false;
  },
  watch: {
    forceOpen(value) {
      if (value) {
        this.open = true;
      }
    }
  }
});
</script>

<style scoped lang="scss">
*, ::v-deep * {
  color: var(--v-neutrals-700-base);

  &::after, &::before {
    color: var(--v-neutrals-700-base);
  }
}

.menu-tree-item {
  &.v-list-item--active::after {
    left: 0;
    width: 4px;
    content: "";
    height: 100%;
    position: absolute;
    border-left: solid 4px var(--v-primary-base) !important;
  }

  &:hover {
    -webkit-text-decoration: none;
    text-decoration: none;
  }

  .v-list-item__icon {
    margin-left: 12px;
    margin-right: 12px;
  }
}

.menu-tree-group {
  ::v-deep {
    .v-list-item__icon.v-list-group__header__prepend-icon {
      margin-left: 12px;
      margin-right: 12px;
    }
  }
}
</style>
